import { useEffect } from "react";
import { useSelector } from "react-redux";
import Viafoura from "../../utils/viafoura/library";

const useViafouraReset = (path) => {
    const vfContainerId = useSelector(
        (state) => state.app.meta["vf:container_id"]
    );

    useEffect(() => {
        if (vfContainerId === "") return;

        if (Viafoura._isViafouraLoaded()) {
            Viafoura.reset();
        } else {
            Viafoura.addOnReadyCallback(() => {
                Viafoura.reset();
            });
        }
    }, [path, vfContainerId]);
};

export default useViafouraReset;
